import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { AppLayoutComponent } from './layout/app.layout.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { AuthGuard } from './shared/guards/auth.guard';

@NgModule({
    imports: [
        RouterModule.forRoot(
            [
                {
                    path: '',
                    pathMatch: 'full',
                    loadChildren: () =>
                        import('./booking/booking.module').then(
                            (m) => m.BookingModule,
                        ),
                    component: AppLayoutComponent,
                    // data: {
                    //     functionCode: 'view booking',
                    // },
                    // canActivate: [AuthGuard],
                },
                {
                    path: 'auth',
                    loadChildren: () =>
                        import('./auth/auth.module').then((m) => m.AuthModule),
                },
                {
                    path: 'booking',
                    loadChildren: () =>
                        import('./booking/booking.module').then(
                            (m) => m.BookingModule,
                        ),
                    component: AppLayoutComponent,
                    data: {
                        functionCode: 'view booking',
                    },
                    canActivate: [AuthGuard],
                },
                {
                    path: 'pending-booking',
                    loadChildren: () =>
                        import('./pending-booking/pending-booking.module').then(
                            (m) => m.PendingBookingModule,
                        ),
                    component: AppLayoutComponent,
                    data: {
                        functionCode: 'view booking',
                    },
                    canActivate: [AuthGuard],
                },
                {
                    path: 'driver',
                    loadChildren: () =>
                        import('./driver/driver.module').then(
                            (m) => m.DriverModule,
                        ),
                    component: AppLayoutComponent,
                    data: {
                        functionCode: 'view driver',
                    },
                    canActivate: [AuthGuard],
                },
                {
                    path: 'call-list',
                    loadChildren: () =>
                        import('./call-list/call-list.module').then(
                            (m) => m.CallListModule,
                        ),
                    component: AppLayoutComponent,
                    data: {
                        functionCode: 'view call',
                    },
                    canActivate: [AuthGuard],
                },
                {
                    path: 'employee',
                    loadChildren: () =>
                        import('./employee/employee.module').then(
                            (m) => m.EmployeeModule,
                        ),
                    component: AppLayoutComponent,
                    data: {
                        functionCode: 'view staff',
                    },
                    canActivate: [AuthGuard],
                },
                {
                    path: 'customer',
                    loadChildren: () =>
                        import('./customer/customer.module').then(
                            (m) => m.CustomerModule,
                        ),
                    component: AppLayoutComponent,
                    // data: {
                    //     functionCode: 'view staff'
                    // },
                    // canActivate: [AuthGuard]
                },
                {
                    path: 'statistical',
                    loadChildren: () =>
                        import('./statistical/statistical.module').then(
                            (m) => m.StatisticalModule,
                        ),
                    component: AppLayoutComponent,
                    // data: {
                    //     functionCode: 'view staff'
                    // },
                    // canActivate: [AuthGuard]
                },
                {
                    path: 'account',
                    loadChildren: () =>
                        import('./account/account.module').then(
                            (m) => m.AccountModule,
                        ),
                },
                {
                    path: 'transaction',
                    loadChildren: () =>
                        import('./transaction/transaction.module').then(
                            (m) => m.TransactionModule,
                        ),
                    component: AppLayoutComponent,
                    data: {
                        functionCode: 'view transaction',
                    },
                    canActivate: [AuthGuard],
                },
                {
                    path: 'e-invoice',
                    loadChildren: () =>
                        import('./e-invoice/e-invoice.module').then(
                            (m) => m.EInvoiceModule,
                        ),
                    component: AppLayoutComponent,
                },
                {
                    path: 'sys-config',
                    loadChildren: () =>
                        import('./system-config/system-config.module').then(
                            (m) => m.SystemConfigModule,
                        ),
                    component: AppLayoutComponent,
                },
                {
                    path: 'trip',
                    loadChildren: () =>
                        import('./trip/trip.module').then((m) => m.TripModule),
                    component: AppLayoutComponent,
                },
                { path: 'notfound', component: NotfoundComponent },
                { path: '**', redirectTo: '/notfound' },
            ],
            {
                scrollPositionRestoration: 'enabled',
                anchorScrolling: 'enabled',
                onSameUrlNavigation: 'reload',
            },
        ),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
